import { render } from "./Nav.vue?vue&type=template&id=496669de"
const script = {}

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__